import requests from "./requests";
import qs from 'qs'
// import mockRequests from "./mockRequests";
//登录的接口:请求体携带参数 phone&&password
// export const reqUserLogin = (data)=>{
//     //requests({url:`api.php?op=vote_review&act=login`,method:'post',data});
//     console.log('login request');
//     return mockRequests({url:`/login`,method:'post',data});
// };


export const reqAnswer = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=exam&con=index&act=add_answer_batch'+data.answerStr,//提交答案
        // data: qs.stringify(data),
        params: {} 
    })
}

export const reqPlayCount = (data, params)=>{
    return requests({
        method: 'get',
        url: '?mod=exam&con=index&act=get_play_count',//提交答案
        // data: qs.stringify(data),
        params: data 
    })
}

export const reqPaperList = (data, params)=>{
    return requests({
        method: 'get',
        url: '?mod=exam&con=index&act=get_paper_json',//提交答案
        // data: qs.stringify(data),
        params: data 
    })
}

export const reqWxAuthorize = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=draw&con=wx&act=getAuthorize',//根据CODE获取微信openId、access_token
        data: qs.stringify(data),
        params: data 
    })
}






// export const reqInit = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=init',//查询活动信息
//         data: qs.stringify(data),
//         params: data 
//     })
// }

// export const reqIsReg = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=isreg',//查询用户是否登记
//         data: qs.stringify(data),
//         params: data 
//     })
// }

// export const reqAdd = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=add',//新增用户登记信息
//         data: qs.stringify(data),
//         params: data 
//     })
// }

// export const reqEdit = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=edit',//修改用户登记信息
//         data: qs.stringify(data),
//         params: data 
//     })
// }

// export const reqLine = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=line',//设置观看时间线
//         data: qs.stringify(data),
//         params: params 
//     })
// }

// export const reqScore = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=score',//观看完成，增加积分
//         data: qs.stringify(data),
//         params: params 
//     })
// }

// export const reqUserInfo = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=userinfo',//用户基本信息
//         data: qs.stringify(data),
//         params: params 
//     })
// }

// export const reqRegInfo = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=learn&con=app&act=reginfo',//用户登记信息
//         data: qs.stringify(data),
//         params: params 
//     })
// }

// export const reqExamScore = (data, params)=>{
//     return requests({
//         method: 'post',
//         url: '?mod=exam&con=wx&act=zl_jcpx_score',//用户登记信息
//         data: qs.stringify(data),
//         params: params 
//     })
// }

// //箭头函数只有一句 可以去掉{}和return
// export const reqBannerList = (data) => requests({ url: '/banner', method: 'get', data });
